var _defs, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M1166.433,617.39c-95.666,133.928,12.539,353.827-128.374,453.826 c-137.168,97.342-302.696-66.321-431.882,17.353c-191.643,124.126-162.959,701.629,111.519,1063.143 c82.544,108.719,152.023,151.414,181.706,273.701c63.74,262.581-171.595,415.906-128.486,545.896 C867.984,3264,2405.414,3524.92,3032.554,2654.955c292.9-406.309,342.299-996.954,89.173-1448.609 C2664.332,390.21,1381.091,316.881,1166.433,617.39z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1864.668,2347.618c-144.735-23.986-289.81-656.1-31.615-917.635 c107.74-109.135,231.255-98.591,317.988-248.819c77.392-134.049,13.251-201.683,72.769-356.937 c83.69-218.304,338.467-418.369,518.668-358.474c90.414,30.052,176.678,130.407,182.095,246.854 c4.339,93.264-88.316,166.484-66.592,190.023c17.842,19.334,73.943-30.697,109.136-11.19 c51.904,28.769,52.702,205.666-29.011,335.673c-139.888,222.563-432.62,166.152-483.36,337.721 c-32.342,109.359,75.514,169.733,30.96,279.896c-39.201,96.925-140.574,94.402-292.651,191.292 C1954.839,2187.793,1942.262,2360.476,1864.668,2347.618z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107587138897440952130000003014001710250236548_",
    gradientUnits: "userSpaceOnUse",
    x1: 2621.6831,
    y1: 680.8978,
    x2: 1951.0441,
    y2: 2414.8252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000107587138897440952130000003014001710250236548_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107565778973269999210000001947568043780929677_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000107565778973269999210000001947568043780929677_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1872.873,2481.281c-3.064,0.198-6.046-1.557-7.262-4.557c-1.071-2.634-0.498-5.528,1.236-7.542 c1.008-4.313,1.257-18.951,1.551-35.743c1.627-94.474,5.957-345.426,140.008-716.393 c168.593-466.55,477.083-947.651,916.901-1429.939c2.729-2.988,7.366-3.201,10.354-0.477c2.991,2.727,3.202,7.363,0.477,10.354 c-472.537,518.162-1038.814,1309.476-1053.086,2136.709c-0.646,37.423-0.761,44.167-7.896,47.063 C1874.408,2481.06,1873.637,2481.232,1872.873,2481.281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2252.711,1237.147c-3.864,0.25-7.288-2.569-7.744-6.459c-0.472-4.02,2.401-7.661,6.423-8.133 c330.87-38.874,537.41-108.205,652.414-159.52c124.525-55.565,171.46-102.532,171.921-103c2.822-2.885,7.462-2.934,10.36-0.104 c2.887,2.828,2.943,7.46,0.118,10.352c-1.927,1.972-48.577,48.899-175.057,105.525 c-116.035,51.95-324.386,122.103-658.046,161.303C2252.971,1237.127,2252.839,1237.139,2252.711,1237.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2441.054,916.858c-1.507,0.098-3.055-0.266-4.424-1.146 c-76.713-49.209-111.203-165.608-102.512-345.962c6.404-132.941,35.206-253.361,35.498-254.561 c0.949-3.94,4.909-6.358,8.844-5.403c3.934,0.95,6.353,4.91,5.399,8.845c-1.139,4.726-112.146,473.878,60.685,584.746 c3.405,2.184,4.397,6.718,2.212,10.125C2445.447,915.539,2443.3,916.712,2441.054,916.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1987.174,1810.126c-2.128,0.138-4.302-0.652-5.86-2.342 c-97.733-105.855-122.401-258.23-125.887-367.417c-3.762-117.82,15.679-212.194,15.877-213.134 c0.83-3.959,4.711-6.498,8.673-5.67c3.963,0.828,6.502,4.712,5.672,8.674c-0.191,0.925-19.309,93.864-15.56,209.995 c3.439,106.587,27.397,255.15,121.992,357.61c2.746,2.974,2.562,7.61-0.412,10.355 C1990.385,1809.382,1988.792,1810.021,1987.174,1810.126z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000172406694109984458450000014333769896773181593_",
    d: "M1888.297,2495.099 c5.08-294.019,61.717-510.107,110.234-648.504c38.083-108.635,102.235-258.027,185.985-259.923 c40.133-0.909,55.405,32.719,97.707,29.935c79.873-5.258,105.773-130.437,173.328-210.625 c115.564-137.174,403.749-202.893,569.868-69.496c200.038,160.636,139.8,543.132-6.95,632.414 c-86.955,52.902-211.198,7.065-229.337,55.597c-18.254,48.844,104.031,104.798,95.006,187.623 c-9.342,85.742-152.128,133.488-160.764,136.274c-172.558,55.661-271.873-63.868-448.513-59.813 C2179.038,2290.782,2046.132,2329.678,1888.297,2495.099z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173843380484816906110000003070104418963227313_",
    gradientUnits: "userSpaceOnUse",
    x1: 2723.8564,
    y1: 1679.3477,
    x2: 2049.7449,
    y2: 2433.3799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172406694109984458450000014333769896773181593_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000173843380484816906110000003070104418963227313_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064316321753189482950000016920987334426972827_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172406694109984458450000014333769896773181593_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000064316321753189482950000016920987334426972827_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1806.058,2715.481l4.331,1.135c175.066-667.257,727.048-1158.341,1476.547-1313.647 l-0.907-4.388c-355.209,73.605-678.191,228.918-934.026,449.148C2083.038,2079.259,1894.255,2379.323,1806.058,2715.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1817.6,1693.553c92.753,164.311,152.983,458.068,134.256,654.834l4.458,0.422 c18.798-197.538-41.68-492.472-134.813-657.458L1817.6,1693.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1841.924,2584.889l3.849,2.291c52.593-88.258,147.786-146.537,282.93-173.218 c99.094-19.565,216.963-22,350.339-7.237l0.49-4.453c-133.827-14.812-252.156-12.359-351.695,7.294 C1991.391,2436.503,1895.197,2495.49,1841.924,2584.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2389.529,1817.881l3.726,2.488c107.692-161.264,104.434-365.154,82.74-507.803l-4.43,0.674 C2493.142,1455.105,2496.425,1657.814,2389.529,1817.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2762.272,1576.818l1.193,4.318c210.586-58.11,423.402,27.281,531.515,83.351l2.064-3.977 C3188.345,1604.137,2974.333,1518.301,2762.272,1576.818z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132065834450012422410000006463788896337175457_",
    gradientUnits: "userSpaceOnUse",
    x1: 860.8007,
    y1: 927.7113,
    x2: 1520.7603,
    y2: 899.0175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132065834450012422410000006463788896337175457_)"
    },
    d: "M1970.96,1259.175 c-9.525,0-17.665-7.78-18.588-18.172c-16.369-184.482-72.37-359.763-157.686-493.562 c-75.579-118.534-165.558-189.267-240.737-189.267c-0.086,0-0.164,0-0.251,0c-273.827,0.573-331.106,675.819-331.651,682.642 c-0.886,11.05-9.899,19.232-20.228,18.285c-10.285-0.951-17.908-10.677-17.024-21.722 c2.346-29.349,60.974-718.718,368.83-719.365c0.109,0,0.221,0,0.329,0c88.828,0,187.791,75.326,271.581,206.733 c88.833,139.319,147.098,321.306,164.058,512.44c0.979,11.04-6.559,20.844-16.837,21.898 C1972.154,1259.146,1971.554,1259.175,1970.96,1259.175z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159431693693263542630000017961543731044895933_",
    gradientUnits: "userSpaceOnUse",
    x1: 791.8158,
    y1: 2002.4443,
    x2: 1409.0583,
    y2: 2002.4443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159431693693263542630000017961543731044895933_)"
    },
    d: "M830.193,2648.889l360.462,196.012 l218.403-719.851l-359.867-965.063l-102.044,26.873L792.317,2572.865C788.812,2604.238,803.946,2634.616,830.193,2648.889z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114758619784971981600000001279255800743502253_",
    gradientUnits: "userSpaceOnUse",
    x1: 958.4557,
    y1: 2002.4438,
    x2: 1409.0583,
    y2: 2002.4438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000114758619784971981600000001279255800743502253_)"
    },
    d: "M1409.058,2125.05 l-359.867-965.063l-60.189,15.851c-8.346,128.85-4.679,234.898,0.99,312.109c24.124,328.574,104.243,420.009,65.431,649.227 c-32.272,190.593-102.749,216.461-96.588,344.691c6.711,139.657,97.399,256.605,205.223,348.572l26.598,14.462L1409.058,2125.05z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088099788268420521840000014429540138233609616_",
    gradientUnits: "userSpaceOnUse",
    x1: 1714.7694,
    y1: 1898.0796,
    x2: 2792.6643,
    y2: 3714.1692
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000088099788268420521840000014429540138233609616_)"
    },
    points: "1049.192,1159.987  2406.632,1233.889 2838.019,2702.33 1190.656,2844.901  "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131332572529020531170000013853824595990519468_",
    gradientUnits: "userSpaceOnUse",
    x1: 1711.629,
    y1: 1736.9043,
    x2: 2584.2422,
    y2: 3786.2249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131332572529020531170000013853824595990519468_)"
    },
    d: "M2406.631,1233.888l-707.915-38.539 c-11.945,18.783-27.768,49.38-30.715,88.415c-17.428,230.867,458.954,305.607,501.635,588.99 c32.494,215.75-167.448,464.691-345.848,575.602c-187.959,116.852-315.315,57.676-442.436,187.406 c-55.855,56.999-89.866,128.277-110.093,202.161l1566.759-135.594L2406.631,1233.888z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035531155454466286560000017394863810163605376_",
    gradientUnits: "userSpaceOnUse",
    x1: 1872.6084,
    y1: 329.5813,
    x2: 1585.682,
    y2: 2778.7095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035531155454466286560000017394863810163605376_)"
    },
    d: "M1465.548,1292.181 c-8.485,0-16.164-6.245-18.186-15.501c-3.82-17.49-92.124-430.765,32.386-633.586c35.687-58.13,85.545-93.621,148.187-105.49 c321.866-60.914,520.034,681.594,528.313,713.232c2.791,10.677-3.001,21.761-12.94,24.761 c-9.949,3.01-20.262-3.226-23.055-13.897c-1.939-7.393-197.008-739.317-485.824-684.545 c-52.856,10.011-93.242,38.811-123.467,88.043c-115.738,188.536-28.097,598.198-27.198,602.316 c2.358,10.794-3.881,21.599-13.931,24.133C1468.398,1292.009,1466.96,1292.181,1465.548,1292.181z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002354430924775906900000004271345732938511028_",
    gradientUnits: "userSpaceOnUse",
    x1: 2023.641,
    y1: 233.723,
    x2: 1193.4617,
    y2: 1813.0857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000002354430924775906900000004271345732938511028_)"
    },
    cx: 1465.679,
    cy: 1295.209,
    rx: 52.246,
    ry: 56.116
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062880266835498690730000006021976399862460607_",
    gradientUnits: "userSpaceOnUse",
    x1: 2546.7434,
    y1: 529.5679,
    x2: 1716.5671,
    y2: 2108.9248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000062880266835498690730000006021976399862460607_)"
    },
    cx: 2147.026,
    cy: 1290.004,
    rx: 52.246,
    ry: 56.116
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2510.515,1940.486l-421.442-410.948c-8.883-8.662-21.605-11.085-32.719-6.233l-224.908,98.191 c-18.953,8.275-25.486,33.575-13.209,51.153l367.06,525.543c10.146,14.526,29.218,17.729,43.008,7.223l279.291-212.786 C2523.853,1980.241,2525.274,1954.878,2510.515,1940.486z M2028.592,1674.005c-14.2,10.254-36.581,1.203-49.989-20.216 c-13.408-21.42-12.765-47.096,1.435-57.35c14.2-10.254,36.581-1.203,49.989,20.216 C2043.435,1638.074,2042.792,1663.75,2028.592,1674.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2510.515,1934.878l-421.442-410.948c-8.883-8.662-21.605-11.085-32.719-6.233l-224.908,98.191 c-18.953,8.275-25.486,33.575-13.209,51.153l367.06,525.543c10.146,14.526,29.218,17.729,43.008,7.224l279.291-212.787 C2523.853,1974.633,2525.274,1949.269,2510.515,1934.878z M2028.592,1668.396c-14.2,10.254-36.581,1.203-49.989-20.216 c-13.408-21.419-12.765-47.096,1.435-57.35c14.2-10.254,36.581-1.203,49.989,20.216 C2043.435,1632.465,2042.792,1658.141,2028.592,1668.396z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M1941.004,1567.474c-1.346,0-2.625-0.791-3.184-2.109c-14.6-34.418-34.291-64.146-58.529-88.361 c-66.411-66.35-152.169-76.783-235.104-86.873c-82.525-10.04-160.475-19.522-207.038-85.196 c-11.787-16.624-30.096-46.67-20.274-61.128c3.94-5.799,11.807-8.468,23.363-7.915c1.908,0.089,3.38,1.709,3.29,3.616 c-0.09,1.908-1.687,3.412-3.618,3.29c-6.187-0.289-14.208,0.32-17.316,4.895c-5.218,7.681,2.708,28.581,20.196,53.242 c44.793,63.178,121.268,72.481,202.231,82.331c84.099,10.231,171.059,20.81,239.156,88.845 c24.869,24.847,45.058,55.314,60.006,90.554c0.746,1.757-0.074,3.787-1.832,4.533 C1941.912,1567.385,1941.454,1567.474,1941.004,1567.474z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M1977.001,1637.018c-0.888,0-1.776-0.34-2.451-1.019c-1.347-1.353-1.34-3.542,0.012-4.889 c0.29-0.29,29.147-29.492,29.005-68.442c-0.086-23.925-10.972-46.701-32.351-67.697 c-45.337-44.522-165.629-96.085-271.761-141.579c-64.778-27.767-125.965-53.995-166.144-76.609 c-9.113-5.13-18.751-9.999-28.651-14.474c-1.739-0.786-2.512-2.834-1.725-4.574c0.785-1.74,2.833-2.515,4.575-1.726 c10.082,4.558,19.904,9.52,29.193,14.749c39.855,22.431,100.874,48.588,165.476,76.28 c106.692,45.733,227.619,97.569,273.883,143.001c22.767,22.357,34.348,46.808,34.421,72.673 c0.118,41.869-29.773,72.039-31.046,73.302C1978.762,1636.684,1977.881,1637.018,1977.001,1637.018z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2510.515,1934.877l-421.443-410.948c-8.883-8.661-21.604-11.084-32.719-6.233l-20.03,8.745 c5.237,19.103,13.078,40.594,25.043,62.533c62.254,114.152,164.388,109.228,187.985,188.449 c20.913,70.209-49.237,107.875-58.484,206.396c-4.621,49.225,5.926,114.706,62.417,196.956l254.311-193.755 C2523.853,1974.632,2525.274,1949.269,2510.515,1934.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2188.824,2085.457c-5.646,0-11.155-3.073-14.301-8.636c-4.787-8.472-2.274-19.512,5.613-24.656 l202.953-132.328c7.888-5.137,18.167-2.438,22.956,6.03c4.787,8.472,2.274,19.512-5.614,24.656l-202.953,132.328 C2194.771,2084.615,2191.778,2085.457,2188.824,2085.457z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016786700150348078930000005136075537135264927_",
    gradientUnits: "userSpaceOnUse",
    x1: 4629.1465,
    y1: 2180.1514,
    x2: 4126.3462,
    y2: 3029.3252,
    gradientTransform: "matrix(-1 0 0 1 6767.0215 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000016786700150348078930000005136075537135264927_)"
    },
    points: "2065.109,2859.5  2585.506,2896.102 2585.506,2133.906 2065.109,2170.508  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159444259940255274610000003237846599777348010_",
    gradientUnits: "userSpaceOnUse",
    x1: 4193.5,
    y1: 2189.0247,
    x2: 3735.5698,
    y2: 2962.4177,
    gradientTransform: "matrix(-1 0 0 1 6767.0215 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    style: {
      stopColor: "#FBA94A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000159444259940255274610000003237846599777348010_)"
    },
    points: "2585.506,2896.102  2976.377,2843.942 2976.377,2182.564 2585.506,2133.906  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2401.284,2146.864 2401.284,2456.134 2226.921,2456.134 2226.921,2159.128  "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.71
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2804.227,2528.571c-17.715-94.619-84.949-142.245-97.552-266.834 c-3.954-39.078-1.604-76.628,4.997-112.125l264.706,32.952v661.377l-323.573,43.179 C2796.814,2727.265,2819.716,2611.299,2804.227,2528.571z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142140061046235066090000013489953722112627383_",
    gradientUnits: "userSpaceOnUse",
    x1: 2567.0354,
    y1: 1482.4148,
    x2: 2729.7839,
    y2: 1482.4148,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142140061046235066090000013489953722112627383_)"
    },
    d: "M998.739,1535.849 c-7.516-3.796-19.597-11.167-29.638-24.527c-10.753-14.308-22.241-39.574-13.286-50.078c4.293-5.035,10.158-3.008,22.484-5.11 c25.654-4.372,32.558-18.66,49.056-24.527c36.233-12.885,90.686,24.826,87.891,43.945c-1.165,7.962-12.256,12.711-32.704,21.462 c-20.955,8.97-29.404,7.854-47.012,15.331C1026.361,1516.238,1013.172,1523.113,998.739,1535.849z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005963314206923135380000001568030287026645434_",
    gradientUnits: "userSpaceOnUse",
    x1: 2652.9387,
    y1: 2808.9978,
    x2: 2928.0762,
    y2: 3068.7358,
    gradientTransform: "matrix(-0.9873 -0.1586 -0.1586 0.9873 3913.1047 205.6246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005963314206923135380000001568030287026645434_)"
    },
    d: "M658.792,2666.68l-3.523-6.111 c0,0-6.325-3.789-9.316,4.049c-2.992,7.837-19.967,48.779-20.87,67.35c4.453,11.112,17.055,1.7,19.654-5.853 c2.6-7.554,11.606-35.567,11.606-35.567L658.792,2666.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123406285101996710450000001878222508044106140_",
    gradientUnits: "userSpaceOnUse",
    x1: 2546.6582,
    y1: 2489.3833,
    x2: 2819.1887,
    y2: 2383.0962,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123406285101996710450000001878222508044106140_)"
    },
    d: "M698.865,2695.905 c-5.264-0.077-10.498-0.04-15.795-0.277c-9.657-0.432-19.365-1.126-29.109-2.096c1.629-10.136,3.256-20.273,4.885-30.409 c4.971-1.898,9.826-3.803,14.576-5.713c2.425-0.977,4.748-1.96,7.117-2.939c2.235-0.923,4.517-1.844,6.703-2.771 c3.214-1.364,6.319-2.733,9.427-4.102c1.235-0.544,2.518-1.085,3.737-1.63c3.648-1.632,7.191-3.268,10.692-4.904 c0.591-0.276,1.21-0.552,1.795-0.827c3.79-1.787,7.48-3.575,11.1-5.369c0.262-0.131,0.54-0.259,0.802-0.39 c3.812-1.894,7.529-3.793,11.157-5.692c0.05-0.027,0.102-0.052,0.153-0.078c7.381-3.87,14.385-7.75,21.033-11.635l0,0 c82.386-48.147,109.628-97.03,118.022-135.469c23.617-108.149-92.021-177.596-62.151-294.873 c22.508-88.377,117.513-164.051,176.014-146.402c66.069,19.93,76.42,147.987,82.792,226.794 c7.173,88.732,15.165,187.584-41.585,276.129c-53.737,83.847-150.816,135.445-262.526,149.177c0,0,0.001,0.011,0.001,0.018 c-2.657,0.325-5.378,0.474-8.05,0.757c-6.477,0.687-12.945,1.403-19.51,1.836c-3.003,0.199-6.06,0.21-9.078,0.355 c-6.401,0.308-12.787,0.661-19.253,0.727C707.522,2696.166,703.178,2695.966,698.865,2695.905z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079447053048228382130000001356206742402172051_",
    gradientUnits: "userSpaceOnUse",
    x1: 2546.6582,
    y1: 2489.3833,
    x2: 2819.1887,
    y2: 2383.0962,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000079447053048228382130000001356206742402172051_)"
    },
    d: "M698.865,2695.905 c-5.264-0.077-10.498-0.04-15.795-0.277c-9.657-0.432-19.365-1.126-29.109-2.096c1.629-10.136,3.256-20.273,4.885-30.409 c4.971-1.898,9.826-3.803,14.576-5.713c2.425-0.977,4.748-1.96,7.117-2.939c2.235-0.923,4.517-1.844,6.703-2.771 c3.214-1.364,6.319-2.733,9.427-4.102c1.235-0.544,2.518-1.085,3.737-1.63c3.648-1.632,7.191-3.268,10.692-4.904 c0.591-0.276,1.21-0.552,1.795-0.827c3.79-1.787,7.48-3.575,11.1-5.369c0.262-0.131,0.54-0.259,0.802-0.39 c3.812-1.894,7.529-3.793,11.157-5.692c0.05-0.027,0.102-0.052,0.153-0.078c7.381-3.87,14.385-7.75,21.033-11.635l0,0 c82.386-48.147,109.628-97.03,118.022-135.469c23.617-108.149-92.021-177.596-62.151-294.873 c22.508-88.377,117.513-164.051,176.014-146.402c66.069,19.93,76.42,147.987,82.792,226.794 c7.173,88.732,15.165,187.584-41.585,276.129c-53.737,83.847-150.816,135.445-262.526,149.177c0,0,0.001,0.011,0.001,0.018 c-2.657,0.325-5.378,0.474-8.05,0.757c-6.477,0.687-12.945,1.403-19.51,1.836c-3.003,0.199-6.06,0.21-9.078,0.355 c-6.401,0.308-12.787,0.661-19.253,0.727C707.522,2696.166,703.178,2695.966,698.865,2695.905z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182503977203075633470000012081162475683852715_",
    gradientUnits: "userSpaceOnUse",
    x1: 2381.8728,
    y1: 1695.6193,
    x2: 2609.1096,
    y2: 1911.6067,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182503977203075633470000012081162475683852715_)"
    },
    d: "M1236.863,2067.284 c12.63-20.039-46.263-49.603-65.408-131.837c-16.165-69.431,16.818-87.02-1.176-179.971 c-10.022-51.769-27.129-81.832-47.067-103.656c-16.432-17.988-37.779-41.355-57.022-38.3 c-60.338,9.58-131.808,284.019-11.242,403.686C1116.899,2078.697,1221.629,2091.454,1236.863,2067.284z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054239170363687037490000004114473931343799469_",
    gradientUnits: "userSpaceOnUse",
    x1: 2233.7942,
    y1: 3167.7156,
    x2: 2226.4731,
    y2: 3529.2708,
    gradientTransform: "matrix(-0.9832 -0.1825 -0.1825 0.9832 3749.0042 160.6767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054239170363687037490000004114473931343799469_)"
    },
    d: "M920.157,2936.222 c2.743-6.328,17.846,9.576,31.915,26.372c-1.812,24.174-3.625,48.347-5.438,72.522c4.996-3.176,11.295-6.646,18.399-8.287 c8.539-1.968,23.297,1.106,24.431,5.187c6.997,25.193-55.825,30.693-62.709,22.779c-6.884-7.917-5.31-17.178-5.31-17.178 c6.376-36.303,5.533-60.889,2.51-77.865C921.831,2947.828,918.643,2939.715,920.157,2936.222z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024696492610788059870000014052789899956907412_",
    gradientUnits: "userSpaceOnUse",
    x1: 2315.9297,
    y1: 2565.8604,
    x2: 2426.7993,
    y2: 2941.584,
    gradientTransform: "matrix(-0.9832 -0.1825 -0.1825 0.9832 3749.0042 160.6767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024696492610788059870000014052789899956907412_)"
    },
    d: "M759.211,2125.465 c35.85-52.856,70.796-106.323,105.829-159.722c6.883-10.492,10.873-22.664,12.792-35.444 c13.911,11.041,27.234,24.258,39.511,39.722c9.864,49.461,25.1,123.813,45.199,213.928 c51.075,228.997,72.573,286.344,83.406,358.375c16.668,110.823,10.76,274.12-99.314,492.792 c-8.396,0.833-16.792,1.667-25.189,2.501c-17.693-187.045-37.987-355.864-48.227-442.621 c-3.475-29.436-13.73-117.74-61.008-188.867c-0.761-1.145-70.719-96.81-94.858-135.031 c-8.036-12.725-18.09-29.231-29.517-51.307C714.941,2191.306,736.661,2158.708,759.211,2125.465z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139288922492349861890000014928733595001320632_",
    gradientUnits: "userSpaceOnUse",
    x1: 2758.8394,
    y1: 2197.3035,
    x2: 2872.3423,
    y2: 2581.9517,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000139288922492349861890000014928733595001320632_)"
    },
    d: "M759.211,2125.465 c35.849-52.856,70.797-106.322,105.829-159.723c6.882-10.493,10.873-22.663,12.792-35.444 c13.911,11.042,27.234,24.259,39.511,39.725c15.637,60.472,26.782,112.198,34.585,151.75 c21.646,109.704,20.415,140.046,4.908,167.285c-21.315,37.446-45.861,27.318-61.437,59.908 c-27.306,57.14,45.815,96.18,45.143,206.365c-0.373,61.097-22.22,76.433-12.274,132.513 c2.567,14.477,9.846,46.281,6.63,89.973c-1.411,19.187-2.958,15.012-4.134,32.349c-3.348,49.393,8.433,94.802,3.329,125.648 c-1.835,11.087-5.607,18.819-7.072,21.634c-3.931,7.554-8.539,12.967-11.779,16.325 c-16.034-161.016-32.963-302.019-42.024-378.777c-3.475-29.434-13.73-117.74-61.008-188.867 c-0.761-1.145-70.719-96.811-94.858-135.033c-8.036-12.723-18.09-29.229-29.517-51.305 C714.941,2191.306,736.662,2158.707,759.211,2125.465z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151543809908742390900000008661978273765473413_",
    gradientUnits: "userSpaceOnUse",
    x1: 2821.2207,
    y1: 1800.4071,
    x2: 3446.4822,
    y2: 2196.6118,
    gradientTransform: "matrix(-0.9995 -0.0302 -0.0302 0.9995 3917.7205 118.8563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151543809908742390900000008661978273765473413_)"
    },
    d: "M1130.186,1663.282 c22.537,41.325,19.97,82.483,17.503,100.497c-7.422,54.18-39.076,90.288-49.702,103.94 c-35.633,45.777-63.422,136.324-19.191,334.809c-24.817-3.982-65.657-7.806-113.244,2.113 c-121.035,25.23-169.352,115.107-227.42,98.723c-21.44-6.048-50.555-28.371-70.858-111.737 c-17.744-43.348-73.036-193.76-16.353-370.642c40.543-126.513,118.531-204.66,157.163-238.649 c33.212-11.186,136.915-41.418,235.584,6.362C1068.253,1600.604,1106.445,1619.754,1130.186,1663.282z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159457277106962731200000005512044844938896268_",
    gradientUnits: "userSpaceOnUse",
    x1: -196.6985,
    y1: -189.5779,
    x2: -231.2843,
    y2: -148.7553,
    gradientTransform: "matrix(0.3449 -0.9386 0.9386 0.3449 1272.5709 1681.9639)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159457277106962731200000005512044844938896268_)"
    },
    d: "M1016.876,1919.594l92.57-32.695 c1.712-0.548,3.076-1.856,3.697-3.543l15.349-41.77c1.586-4.314-2.212-8.681-6.705-7.71l-86.977,18.813 c-1.99,0.43-6.423,1.718-7.781,5.417l-17.222,50.943C1008.237,1913.588,1012.303,1921.057,1016.876,1919.594z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121237154363703263570000000239711030997784716_",
    gradientUnits: "userSpaceOnUse",
    x1: -312.5013,
    y1: -123.5927,
    x2: -122.5511,
    y2: -123.5927,
    gradientTransform: "matrix(0.3449 -0.9386 0.9386 0.3449 1272.5709 1681.9639)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121237154363703263570000000239711030997784716_)"
    },
    d: "M1018.295,1920.124l89.455-28.613 c1.712-0.549,3.076-1.855,3.697-3.543l15.349-41.769c1.586-4.315-2.211-8.682-6.705-7.711l-86.977,18.812 c-1.99,0.431-3.612,1.87-4.278,3.794l-17.828,51.572C1009.439,1917.205,1013.722,1921.588,1018.295,1920.124z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010272849317663141640000012802713785609594285_",
    gradientUnits: "userSpaceOnUse",
    x1: -607.0521,
    y1: -48.5116,
    x2: -486.7321,
    y2: -48.5116,
    gradientTransform: "matrix(-0.8308 0.5567 0.5567 0.8308 560.2872 2252.583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010272849317663141640000012802713785609594285_)"
    },
    d: "M977.737,1892.178l10.009-4.754 c0,0,15.737-11.522,26.311-16.164c10.573-4.642,19.133-3.536,25.687,6.244c6.555,9.781-4.574,18.981-14.124,27.059 c-5.809,4.913-17.924,5.352-27.727,4.83c-6.892-0.366-20.681,4.406-20.681,4.406L977.737,1892.178z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014614663678437770600000017357422751517864369_",
    gradientUnits: "userSpaceOnUse",
    x1: -549.7073,
    y1: 2411.4136,
    x2: -538.1912,
    y2: 2104.6643,
    gradientTransform: "matrix(0.9261 0.3773 -0.3773 0.9261 2366.8079 -288.2454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014614663678437770600000017357422751517864369_)"
    },
    d: "M996.664,1499.542 c0.031,8.732-0.306,55.488-21.081,63.164c-4.541,1.678-8.188,0.608-28.332,1.133c-11.483,0.3-20.826,0.914-26.843,1.376 c1.021,7.966,3.028,18.651,7.297,30.665c25.851,72.74,109.525,123.276,137.871,105.073 c14.763-9.479,15.901-37.916,16.374-49.716c0.709-17.723-3.564-31.764-6.683-39.802 c-10.378-7.538-20.995-15.096-31.855-22.653c-7.094-4.938-14.149-9.779-21.163-14.525c0.473-8.948,0.948-17.893,1.421-26.84 C1014.668,1531.46,1005.666,1515.5,996.664,1499.542z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036243657825692339430000014389590445493115782_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.4631,
    y1: 1991.4747,
    x2: -49.6285,
    y2: 1815.7653,
    gradientTransform: "matrix(0.9786 0.206 -0.206 0.9786 1441.7991 -233.1068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036243657825692339430000014389590445493115782_)"
    },
    d: "M987.597,1516.786 c0,0-0.099,38.479,30.623,50.994c27.508,11.207,63.588-53.374,52.715-74.331c-3.628-6.992-14.486-15.202-24.999-17.101 c-7.392-1.335-38.075-1.518-46.769,22.591c-2.586-7.622-7.734-12.563-13.052-12.618c-0.849-0.01-3.285,0.347-5.231,1.736 C973.842,1493.077,975.845,1504.828,987.597,1516.786z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147189534786083139540000012382687798295746192_",
    gradientUnits: "userSpaceOnUse",
    x1: 2806.9834,
    y1: 1796.899,
    x2: 3448.9546,
    y2: 2203.6919,
    gradientTransform: "matrix(-0.9995 -0.0302 -0.0302 0.9995 3917.7205 118.8563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000147189534786083139540000012382687798295746192_)"
    },
    d: "M650.92,1820.985 c31.72-98.981,86.294-168.224,127.075-210.01c46.753,30.902,94.317,72.778,90.346,117.678 c-4.519,51.093-72.776,72.208-66.402,104.516c9.24,46.832,157.922,29.092,175.274,80.63 c20.446,60.734-155.85,174.961-146.422,187.893c6.744,9.251,87.832-56.114,179.87-40.88 c17.855,2.954,33.854,9.917,48.108,19.089c3.277,35.501,9.647,76.059,20.026,122.626c-24.817-3.982-65.657-7.806-113.244,2.113 c-121.035,25.23-169.352,115.107-227.42,98.723c-21.44-6.048-50.555-28.371-70.858-111.737 C649.529,2148.28,594.237,1997.867,650.92,1820.985z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088098072481979073800000003213006405172522659_",
    gradientUnits: "userSpaceOnUse",
    x1: 2798.0217,
    y1: 1761.6355,
    x2: 3128.7263,
    y2: 1971.1904,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088098072481979073800000003213006405172522659_)"
    },
    d: "M873.902,1585.826 c-28.099-7.001-28.241-16.139-65.819-3.489c-107.91,36.325-222.146,199.178-163.107,314.175 c32.837,63.962,111.519,121.636,198.267,108.331c70.616-10.831,112.093-63.412,122.639-77.672 c4.088-16.352,8.175-32.703,12.263-49.055c-46.019,26.088-78.432,26.08-100.154,20.439 c-36.976-9.6-45.187-36.096-106.287-59.275c-23.804-9.031-38.104-10.907-38.835-18.396 c-1.511-15.485,58.336-20.652,96.067-53.144C856.44,1744.056,883.881,1695.779,873.902,1585.826z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114761396256157990590000012902603618919063215_",
    gradientUnits: "userSpaceOnUse",
    x1: 1361.6766,
    y1: 3029.4512,
    x2: 1382.6135,
    y2: 3047.0571,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114761396256157990590000012902603618919063215_)"
    },
    d: "M2241.985,3063.827 c0,27.494,16.943,49.781,37.844,49.781c20.9,0,37.843-22.287,37.843-49.781c0-27.493-16.943-49.781-37.843-49.781 C2258.928,3014.046,2241.985,3036.334,2241.985,3063.827z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147181493409030390860000014013018610894383285_",
    gradientUnits: "userSpaceOnUse",
    x1: 1375.2542,
    y1: 3069.447,
    x2: 1450.9412,
    y2: 3069.447,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147181493409030390860000014013018610894383285_)"
    },
    d: "M2231.444,3069.447 c0,27.494,16.942,49.781,37.843,49.781s37.844-22.287,37.844-49.781c0-27.493-16.943-49.781-37.844-49.781 S2231.444,3041.954,2231.444,3069.447z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157303825799847677040000009620375840795939511_",
    gradientUnits: "userSpaceOnUse",
    x1: 1397.2367,
    y1: 3070.45,
    x2: 1428.9517,
    y2: 3070.45,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157303825799847677040000009620375840795939511_)"
    },
    d: "M2253.433,3070.449 c0,11.521,7.1,20.86,15.857,20.86c8.757,0,15.858-9.339,15.858-20.86c0-11.52-7.101-20.859-15.858-20.859 C2260.533,3049.59,2253.433,3058.93,2253.433,3070.449z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M2279.829,3008.684v54.663c0,8.027-6.506,14.533-14.533,14.533l0,0 c-4.638,0-9-2.215-11.735-5.961l-49.164-67.32L2279.829,3008.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067926423266674306990000016727608574082749602_",
    gradientUnits: "userSpaceOnUse",
    x1: 1766.8375,
    y1: 2985.7981,
    x2: 1787.7744,
    y2: 3003.4043,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067926423266674306990000016727608574082749602_)"
    },
    d: "M1836.824,3020.174 c0,27.494,16.943,49.782,37.844,49.782c20.9,0,37.843-22.288,37.843-49.782c0-27.492-16.943-49.781-37.843-49.781 C1853.767,2970.392,1836.824,2992.681,1836.824,3020.174z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121973279216367183330000016369632629613090951_",
    gradientUnits: "userSpaceOnUse",
    x1: 1780.4161,
    y1: 3025.7952,
    x2: 1856.1031,
    y2: 3025.7952,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121973279216367183330000016369632629613090951_)"
    },
    d: "M1826.282,3025.795 c0,27.493,16.943,49.782,37.843,49.782c20.901,0,37.844-22.289,37.844-49.782c0-27.493-16.943-49.781-37.844-49.781 C1843.225,2976.013,1826.282,2998.301,1826.282,3025.795z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059991908408088513400000002062439495216366230_",
    gradientUnits: "userSpaceOnUse",
    x1: 1802.3987,
    y1: 3026.7974,
    x2: 1834.1125,
    y2: 3026.7974,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059991908408088513400000002062439495216366230_)"
    },
    d: "M1848.272,3026.797 c0,11.521,7.099,20.86,15.858,20.86c8.757,0,15.856-9.339,15.856-20.86s-7.1-20.859-15.856-20.859 C1855.371,3005.938,1848.272,3015.276,1848.272,3026.797z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M1874.668,2965.03v54.665c0,8.025-6.506,14.532-14.533,14.532l0,0 c-4.639,0-9-2.215-11.736-5.961l-49.162-67.32L1874.668,2965.03z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2285.48,3017.178c4.981,0,9.274-3.746,9.846-8.814c0.615-5.447-3.305-10.355-8.751-10.971 l-479.809-54.068c-26.113-4.492-47.89-24.34-54.916-50.482l-200.989-748.298c-10.704-39.846-45.549-68.518-86.704-71.353 l-145.947-8.703c-5.485-0.378-10.171,3.843-10.496,9.313c-0.329,5.471,3.843,10.171,9.313,10.496l145.855,8.698 c32.616,2.249,60.304,25.033,68.809,56.694l200.989,748.299c9.027,33.6,37.016,59.103,71.299,64.98l480.376,54.146 C2284.734,3017.159,2285.107,3017.178,2285.48,3017.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1951.667,2722.61c4.318,0,8.291-2.844,9.536-7.201l112.987-395.359 c1.507-5.272-1.546-10.762-6.813-12.269c-5.262-1.502-10.762,1.551-12.269,6.813l-112.987,395.359 c-1.507,5.272,1.546,10.762,6.813,12.269C1949.845,2722.484,1950.765,2722.61,1951.667,2722.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1836.078,2706.076c4.72,0,8.906-3.377,9.759-8.184l69.691-391.632 c0.959-5.398-2.636-10.549-8.029-11.509c-5.447-0.984-10.554,2.636-11.509,8.029l-69.69,391.632 c-0.959,5.398,2.636,10.549,8.029,11.509C1834.92,2706.028,1835.501,2706.076,1836.078,2706.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1764.26,2693.24c0.136,0,0.276-0.005,0.417-0.01c5.476-0.228,9.73-4.851,9.502-10.326 l-16.083-387.489c-0.223-5.476-4.608-9.822-10.326-9.502c-5.476,0.228-9.73,4.851-9.502,10.326l16.083,387.489 C1754.569,2689.063,1758.969,2693.24,1764.26,2693.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2109.325,2737.074c4.148,0,8.015-2.622,9.41-6.774l132.66-395.533 c1.74-5.195-1.056-10.821-6.256-12.565c-5.195-1.73-10.82,1.056-12.565,6.256l-132.66,395.533 c-1.74,5.194,1.056,10.82,6.256,12.565C2107.218,2736.905,2108.279,2737.074,2109.325,2737.074z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049187574701693484450000002490797166486018957_",
    gradientUnits: "userSpaceOnUse",
    x1: 2359.1921,
    y1: 2085.4846,
    x2: 2725.4197,
    y2: 2085.4846,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049187574701693484450000002490797166486018957_)"
    },
    d: "M976.789,2118.756 c0.548,0,1.095-0.019,1.652-0.068l326.531-26.845c10.922-0.896,19.053-10.481,18.152-21.408 c-0.896-10.927-10.491-19.068-21.408-18.152l-326.531,26.845c-10.922,0.896-19.053,10.481-18.152,21.408 C957.886,2110.906,966.565,2118.756,976.789,2118.756z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095315290950036768150000011302548699946560159_",
    gradientUnits: "userSpaceOnUse",
    x1: 1717.1454,
    y1: 3165.2214,
    x2: 1738.0823,
    y2: 3182.8274,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095315290950036768150000011302548699946560159_)"
    },
    d: "M1886.516,3199.598 c0,27.493,16.943,49.781,37.843,49.781c20.902,0,37.844-22.288,37.844-49.781c0-27.493-16.942-49.781-37.844-49.781 C1903.459,3149.816,1886.516,3172.104,1886.516,3199.598z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018954623827841887130000004811447272089672592_",
    gradientUnits: "userSpaceOnUse",
    x1: 1730.723,
    y1: 3205.218,
    x2: 1806.4099,
    y2: 3205.218,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018954623827841887130000004811447272089672592_)"
    },
    d: "M1875.975,3205.218 c0,27.493,16.942,49.782,37.843,49.782c20.9,0,37.844-22.289,37.844-49.782c0-27.493-16.944-49.781-37.844-49.781 C1892.917,3155.436,1875.975,3177.724,1875.975,3205.218z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002381214633923167060000015649528059886490518_",
    gradientUnits: "userSpaceOnUse",
    x1: 1752.7054,
    y1: 3206.2205,
    x2: 1784.4207,
    y2: 3206.2205,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002381214633923167060000015649528059886490518_)"
    },
    d: "M1897.964,3206.22 c0,11.521,7.099,20.86,15.858,20.86c8.757,0,15.858-9.34,15.858-20.86c0-11.52-7.101-20.859-15.858-20.859 C1905.063,3185.361,1897.964,3194.7,1897.964,3206.22z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M1924.359,3144.454v54.663c0,8.027-6.506,14.533-14.532,14.533l0,0 c-4.639,0-9-2.215-11.736-5.962l-49.163-67.319L1924.359,3144.454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180333582492198867880000006589809628951584443_",
    gradientUnits: "userSpaceOnUse",
    x1: 2067.9282,
    y1: 3130.1045,
    x2: 2088.8652,
    y2: 3147.7104,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180333582492198867880000006589809628951584443_)"
    },
    d: "M1535.733,3164.481 c0,27.493,16.943,49.781,37.843,49.781c20.901,0,37.844-22.288,37.844-49.781c0-27.494-16.943-49.781-37.844-49.781 C1552.677,3114.699,1535.733,3136.986,1535.733,3164.481z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105399962947701296420000005346304535652462517_",
    gradientUnits: "userSpaceOnUse",
    x1: 2081.5066,
    y1: 3170.1006,
    x2: 2157.1936,
    y2: 3170.1006,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105399962947701296420000005346304535652462517_)"
    },
    d: "M1525.191,3170.101 c0,27.494,16.943,49.781,37.843,49.781s37.844-22.287,37.844-49.781c0-27.493-16.944-49.781-37.844-49.781 S1525.191,3142.607,1525.191,3170.101z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047034529692526174330000016192326558156570023_",
    gradientUnits: "userSpaceOnUse",
    x1: 2103.489,
    y1: 3171.1025,
    x2: 2135.2031,
    y2: 3171.1025,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047034529692526174330000016192326558156570023_)"
    },
    d: "M1547.182,3171.103 c0,11.52,7.099,20.859,15.857,20.859s15.858-9.339,15.858-20.859c0-11.521-7.1-20.86-15.858-20.86 S1547.182,3159.582,1547.182,3171.103z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M1573.576,3109.337V3164c0,8.026-6.506,14.533-14.532,14.533l0,0c-4.641,0-9-2.216-11.737-5.962 l-49.162-67.32L1573.576,3109.337z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2434.756,2350.602c5.156,0,9.512-3.988,9.89-9.211c0.393-5.466-3.721-10.219-9.187-10.612 l-854.54-61.511c-0.8-0.039-1.594-0.02-2.379,0.116l-353.768,60.256c-5.403,0.921-9.037,6.048-8.116,11.45 c0.921,5.398,5.979,9.037,11.45,8.116l352.586-60.057l853.343,61.428C2434.277,2350.593,2434.519,2350.602,2434.756,2350.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M2144.389,2438.76c0.974,0,1.948-0.145,2.883-0.426l290.358-88.157 c5.243-1.594,8.204-7.138,6.614-12.381c-1.599-5.243-7.167-8.189-12.381-6.615l-288.473,87.586l-915.988-89.219 c-5.544-0.596-10.312,3.46-10.84,8.911c-0.533,5.456,3.46,10.312,8.911,10.84l917.95,89.412 C2143.749,2438.745,2144.069,2438.76,2144.389,2438.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M1336.968,2750.666c0.504,0,1.008-0.039,1.521-0.116l348.113-53.409l529.618,50.976 c5.451,0.514,10.307-3.479,10.83-8.93c0.523-5.456-3.474-10.302-8.931-10.83l-530.849-51.093 c-0.809-0.077-1.648-0.058-2.457,0.073l-349.339,53.598c-5.418,0.828-9.134,5.897-8.301,11.315 C1327.926,2747.153,1332.157,2750.666,1336.968,2750.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M1968.176,2810.68c3.804,0,7.312-2.185,8.964-5.674l176.218-371.92 c2.345-4.952,0.233-10.869-4.72-13.219c-4.947-2.335-10.874-0.237-13.219,4.72l-173.238,365.631l-624.259-59.355 c-5.534-0.523-10.302,3.489-10.82,8.94c-0.518,5.456,3.484,10.302,8.94,10.821l631.188,60.014 C1967.546,2810.666,1967.861,2810.68,1968.176,2810.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M1968.161,2810.68c0.804,0,1.614-0.097,2.428-0.3l249-62.519c2.68-0.674,4.962-2.433,6.29-4.86 l217.576-397.559c2.631-4.807,0.863-10.84-3.944-13.471c-4.812-2.621-10.84-0.858-13.471,3.945l-215.492,393.755 l-244.794,61.463c-5.316,1.333-8.543,6.726-7.206,12.042C1959.677,2807.676,1963.723,2810.68,1968.161,2810.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M2080.295,2574.037c0.945,0,1.885-0.136,2.791-0.402l273.461-80.153 c5.258-1.541,8.271-7.055,6.73-12.313c-1.536-5.258-7.079-8.276-12.313-6.731l-271.668,79.624l-807.493-70.422 c-5.553-0.547-10.273,3.566-10.748,9.023c-0.48,5.461,3.562,10.273,9.023,10.748l809.354,70.587 C2079.719,2574.022,2080.009,2574.037,2080.295,2574.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M2013.483,2715.041c0.901,0,1.803-0.121,2.675-0.368l261.981-73.393 c5.282-1.478,8.359-6.954,6.881-12.23c-1.478-5.282-6.954-8.369-12.23-6.881l-260.242,72.903l-701.194-61.342 c-5.447-0.577-10.273,3.562-10.748,9.023c-0.48,5.456,3.562,10.273,9.023,10.748l702.991,61.501 C2012.906,2715.026,2013.197,2715.041,2013.483,2715.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M1839.286,2798.43c4.274,0,8.223-2.786,9.507-7.094l112.381-377.032 c1.565-5.253-1.425-10.781-6.677-12.347c-5.233-1.57-10.777,1.42-12.347,6.677l-112.381,377.032 c-1.565,5.253,1.425,10.782,6.677,12.347C1837.391,2798.294,1838.346,2798.43,1839.286,2798.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M1714.975,2786.607c4.729,0,8.916-3.387,9.764-8.199l67.403-381.985 c0.95-5.398-2.651-10.544-8.049-11.499c-5.379-0.94-10.549,2.656-11.499,8.049l-67.403,381.985 c-0.95,5.398,2.651,10.544,8.049,11.499C1713.821,2786.558,1714.403,2786.607,1714.975,2786.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M1574.77,2770.65c5.229,0,9.604-4.085,9.9-9.367l21.244-379.286 c0.305-5.476-3.881-10.161-9.352-10.467c-5.51-0.213-10.161,3.881-10.467,9.352l-21.244,379.286 c-0.305,5.476,3.881,10.161,9.352,10.467C1574.392,2770.645,1574.581,2770.65,1574.77,2770.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M1441.921,2755.779c0.174,0,0.354-0.005,0.528-0.015c5.476-0.286,9.677-4.957,9.391-10.428 l-20.211-385.338c-0.286-5.471-4.904-9.672-10.428-9.391c-5.476,0.286-9.677,4.957-9.391,10.428l20.211,385.338 C1432.297,2751.669,1436.678,2755.779,1441.921,2755.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M2043.473,2791.772c3.692,0,7.239-2.069,8.95-5.621l181.63-377.522 c2.379-4.938,0.301-10.869-4.637-13.243c-4.933-2.37-10.874-0.296-13.248,4.637l-181.63,377.522 c-2.379,4.938-0.3,10.869,4.637,13.248C2040.561,2791.457,2042.029,2791.772,2043.473,2791.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M2144.379,2766.434c3.644,0,7.152-2.011,8.887-5.49l192.805-386.215 c2.452-4.904,0.46-10.864-4.444-13.311c-4.914-2.462-10.874-0.456-13.311,4.444l-192.804,386.215 c-2.452,4.904-0.46,10.864,4.443,13.311C2141.38,2766.1,2142.892,2766.434,2144.379,2766.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DBE2"
    },
    d: "M1926.261,3159.738c1.25,0,2.491-0.237,3.658-0.698l359.205-142.56 c5.098-2.026,7.588-7.792,5.568-12.885c-2.021-5.098-7.797-7.588-12.885-5.568l-356.855,141.629l-433.31-52.934 c-30.843-3.765-56.103-25.561-64.36-55.517l-237.53-862.327c-10.84-39.357-45.477-67.781-86.19-70.732l-126.031-9.139 c-5.408-0.315-10.219,3.712-10.617,9.183c-0.393,5.466,3.717,10.219,9.182,10.617l126.031,9.139 c32.355,2.34,59.878,24.926,68.494,56.205l237.53,862.327c10.399,37.743,42.225,65.199,81.088,69.948l435.82,53.239 C1925.456,3159.714,1925.859,3159.738,1926.261,3159.738z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020370928960975964250000013204081288001939614_",
    gradientUnits: "userSpaceOnUse",
    x1: 2470.9626,
    y1: 2007.4279,
    x2: 2431.6162,
    y2: 2068.2363,
    gradientTransform: "matrix(-1 0 0 1 3682.3848 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020370928960975964250000013204081288001939614_)"
    },
    d: "M1206.714,2064.219 c3.137-0.108,46.847-1.339,51.002,11.597c1.179,3.668,0.097,7.309,0.097,7.309c-2.293,7.72-11.893,10.368-13.286,10.732 c14.7,9.405,32.426,6.88,40.88-3.577c5.919-7.321,7.633-18.943,2.937-27.872c-4.348-8.269-12.578-11.476-17.244-13.008 C1238.395,2038.669,1206.714,2064.219,1206.714,2064.219z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.96ea818e15c8a179b910b9dad1b93e67.svg";
export { ForwardRef as ReactComponent };